var $6f40c3a58f594b58$exports = {};
console.log('Hello world!'); // const foo = (a,b) => a*b;
 // console.log(foo(2.5,5));


//# sourceMappingURL=test-parcel.d85c7983.js.map
